import { Alert } from "@jugl-web/ui-components/cross-platform/Alert";
import { useTranslations } from "@jugl-web/utils";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import warningAnimation from "./assets/warningAnimation.json";

interface ComponentProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onRequestClose: () => void;
  itemType: string;
  isDisabled: boolean;
}

export const InvoiceDeleteConfirmationDialog = ({
  isOpen,
  onCancel,
  onConfirm,
  onRequestClose,
  itemType,
  isDisabled,
}: ComponentProps) => {
  const { t } = useTranslations();

  return (
    <div>
      <Alert
        isOpen={isOpen}
        img={
          <Lottie
            options={{
              animationData: warningAnimation,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
              },
            }}
            width={80}
            height={80}
          />
        }
        title={t({
          id: "invoices.delete-confirmation-title",
          defaultMessage: "Confirm Action",
        })}
        content={t(
          {
            id: "invoices.delete-confirmation-content",
            defaultMessage:
              "This {itemType} will be permanently deleted. This action is permanent and cannot be undone.",
          },
          {
            itemType: itemType.toLowerCase(),
          }
        )}
        buttons={[
          {
            text: t({
              id: "common.cancel",
              defaultMessage: "Cancel",
            }),
            role: "close",
            onClick: onCancel,
          },
          {
            text: t({
              id: "invoices.delete-confirm-button",
              defaultMessage: "Delete",
            }),
            color: "tertiary",
            onClick: onConfirm,
            isDisabled,
          },
        ]}
        onRequestClose={onRequestClose}
      />
    </div>
  );
};
